import { render, staticRenderFns } from "./GeofenceForm.vue?vue&type=template&id=619b9f55&scoped=true&"
import script from "./GeofenceForm.vue?vue&type=script&lang=js&"
export * from "./GeofenceForm.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceForm.vue?vue&type=style&index=0&id=619b9f55&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619b9f55",
  null
  
)

export default component.exports